import { useQuery } from '@tanstack/react-query';
import { queryKeys, type UsersListFilters } from '@/core/data-fetching/queryKeys';
import { usersService, type PaginationParams } from '../api/users.service';

export function useUsersListQuery(filters: UsersListFilters) {
  return useQuery({
    queryKey: queryKeys.users.list(filters),
    queryFn: () =>
      usersService.list({
        page: filters.page,
        limit: filters.limit,
        search: filters.search,
        role: filters.role ? (filters.role as NonNullable<PaginationParams['role']>) : undefined,
        isActive: filters.isActive,
      }),
  });
}
